"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageCrop = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const hui_1 = require("@mit/hui");
require("react-image-crop/dist/ReactCrop.css");
const react_image_crop_1 = __importDefault(require("react-image-crop"));
const defaultCrop = { unit: '%', width: 65, aspect: 16 / 9 };
const ImageCrop = ({ showCropModal, uploadImage, onCloseCropModal, handleCropImage }) => {
    var _a, _b;
    const [crop, setCrop] = (0, react_1.useState)(Object.assign({}, defaultCrop));
    const [completedCrop, setCompletedCrop] = (0, react_1.useState)(Object.assign({}, defaultCrop));
    const previewCanvasRef = (0, react_1.useRef)(null);
    const imgRef = (0, react_1.useRef)(null);
    // const { mobile } = useStoreState(store => store.GlobalModel)
    const onCropImage = () => {
        const canvas = previewCanvasRef.current;
        canvas.toBlob((blob) => {
            const previewUrl = window.URL.createObjectURL(blob);
            handleCropImage(blob, previewUrl);
        }, 'image/*', 1);
    };
    const cropSelect = (c) => {
        delete c.aspect;
        setCrop(c);
    };
    const onLoad = (0, react_1.useCallback)(img => {
        imgRef.current = img;
        setCrop(Object.assign({}, defaultCrop));
        return false;
    }, []);
    (0, react_1.useEffect)(() => {
        // eslint-disable-next-line
        if (!completedCrop || !previewCanvasRef.current || !imgRef.current) {
            return;
        }
        const image = imgRef.current;
        const canvas = previewCanvasRef.current;
        const crop = completedCrop;
        const scaleX = image.naturalWidth / image.width;
        const scaleY = image.naturalHeight / image.height;
        const ctx = canvas.getContext('2d');
        const pixelRatio = window.devicePixelRatio;
        canvas.width = crop.width * pixelRatio;
        canvas.height = crop.height * pixelRatio;
        ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        ctx.imageSmoothingQuality = 'high';
        ctx.drawImage(image, crop.x * scaleX, crop.y * scaleY, crop.width * scaleX, crop.height * scaleY, 0, 0, crop.width, crop.height);
    }, [completedCrop]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(hui_1.TemplateModal, { name: 'pictureCropper', show: showCropModal, autoHeight: true, bodyAlignment: hui_1.TemplateModalAlignment.Center, size: hui_1.TemplateModalSize.Large, header: (0, jsx_runtime_1.jsx)(hui_1.Text, { content: 'Crop image', type: hui_1.TextType.Heading2 }), body: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: 'crop-description text-left' }, { children: (0, jsx_runtime_1.jsxs)("ol", { children: [(0, jsx_runtime_1.jsxs)("li", { children: [(0, jsx_runtime_1.jsx)("b", { children: "Pull the corners" }), " of the selection to the desired size. Should the selection dissappear, simply drag and select an area on the canvas."] }), (0, jsx_runtime_1.jsxs)("li", { children: [(0, jsx_runtime_1.jsx)("b", { children: "Move the selection area" }), " to cover the area of the photo at the ideal position."] }), (0, jsx_runtime_1.jsxs)("li", { children: ["Press ", (0, jsx_runtime_1.jsx)("b", { children: "Crop Image" }), " at the bottom right."] })] }) })), (0, jsx_runtime_1.jsx)(react_image_crop_1.default, { src: uploadImage, onImageLoaded: onLoad, keepSelection: true, crop: crop, onChange: c => cropSelect(c), onComplete: c => setCompletedCrop(c), imageStyle: { maxHeight: '65vh' } })] }), footer: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(hui_1.ButtonBar, { buttons: [{ icon: 'crop', text: 'Crop Image', onClick: onCropImage }] }) }) }), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: 'ImageCrop', style: { display: 'none' } }, { children: (0, jsx_runtime_1.jsx)("canvas", { ref: previewCanvasRef, 
                    // Rounding is important so the canvas width and height matches/is a multiple for sharpness.
                    style: {
                        width: Math.round((_a = completedCrop === null || completedCrop === void 0 ? void 0 : completedCrop.width) !== null && _a !== void 0 ? _a : 0),
                        height: Math.round((_b = completedCrop === null || completedCrop === void 0 ? void 0 : completedCrop.height) !== null && _b !== void 0 ? _b : 0)
                    } }) }))] }));
};
exports.ImageCrop = ImageCrop;
